/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_Table_PriceInputs */

const es_billing_events_table_price = /** @type {(inputs: Billing_Events_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const en_billing_events_table_price = /** @type {(inputs: Billing_Events_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Billing_Events_Table_PriceInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_table_price = /** @type {((inputs?: Billing_Events_Table_PriceInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Table_PriceInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_table_price(inputs)
	return en_billing_events_table_price(inputs)
});
export { billing_events_table_price as "billing.events.table.price" }